import { render, staticRenderFns } from "./InvoiceCharts.vue?vue&type=template&id=960faf22&scoped=true&"
import script from "./InvoiceCharts.vue?vue&type=script&lang=js&"
export * from "./InvoiceCharts.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCharts.vue?vue&type=style&index=0&id=960faf22&scoped=true&lang=scss&"
import style1 from "./InvoiceCharts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960faf22",
  null
  
)

export default component.exports